'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Feedback = function Feedback(_ref) {
    var error = _ref.error,
        id = _ref.id;
    return _react2.default.createElement("span", { className: "luna-form__feedback", id: 'inputFeedbackText-' + id }, error);
};
Feedback.propTypes = {
    error: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
    id: _propTypes2.default.string.isRequired
};
Feedback.defaultProps = {
    error: false
};
exports.default = Feedback;
//# sourceMappingURL=Feedback.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Input/Feedback.js